@if (selectedOptions() && selectedOptions().length > 0) {
  <div class="mt-2">
    @for (option of selectedOptions(); track $index) {
      <button 
        class="tag-filter btn btn-primary" 
        type="button" 
        (click)="removeOption($index)"
        [disabled]="disabled()">
        {{ option | formatLabel }}
        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="px-0"/>
      </button>
    }
  </div>
}
    
<select
  class="form-select"
  [value]="''"
  (change)="onSelectionChange($event)"
  [disabled]="disabled()">
  <option value="" disabled selected>{{ placeholder() }}</option>
  @if (isLoading()) {
    <option value="" disabled>{{ loadingText() }}</option>
  } @else {
    @for (option of options(); track option) {
      <option
        [value]="option"
        [disabled]="isOptionSelected(option)"
        [class.selected-option]="isOptionSelected(option)">
        {{ option | formatLabel }}
      </option>
    }
  }
</select>
